__webpack_require__.p = "https://imp.sandbox-eu.pandium.com/";